import { SET_HEADER_MODE } from '../../shared/common/constants';

export const setHeaderMode = (mode) => ({
  type: SET_HEADER_MODE,
  payload: mode,
});
